<script lang="ts" setup>
import { defineProps, defineEmits, ref, watch, computed, StyleValue } from 'vue';
import NumberInputWithComma from '@/corePagesModule/components/NumberInputWithComma.vue';

const props = defineProps<{
  modelValue: number;
  placeholder: string;
  label: string;
  disabled?: boolean;
  hasBorder?: boolean;
}>();

const emits = defineEmits<{
  (e: 'update:modelValue', value: number): void;
}>();

const value = ref(props.modelValue);

/**
 * テキスト入力の値が変更されたときに呼び出されるハンドラ
 * @param value - 変更された値
 */
const onInput = (value: string) => {
  emits('update:modelValue', Number(value));
};

/**
 * テキスト入力の値を更新します。
 * @param value - 更新する値
 */
const updateAmount = (value: number) => {
  emits('update:modelValue', value);
};

watch(
  () => props.modelValue,
  () => {
    value.value = props.modelValue;
  }
);

watch(
  () => value.value,
  () => {
    emits('update:modelValue', value.value);
  }
);

const inputBorderStyle = computed((): StyleValue => {
  return props.hasBorder ? { border: '1px solid #212121', borderRadius: '4px', overflow: 'hidden' } : {};
});
</script>
<template>
  <div class="text-input__container">
    <div class="text-input__label">
      <p class="text-input__label-text">{{ label }}</p>
    </div>
    <div class="text-input" :style="inputBorderStyle">
      <NumberInputWithComma
        class="text-input__body"
        :placeholder="props.placeholder"
        :disabled="props.disabled"
        :model-value="props.modelValue"
        @update:model-value="updateAmount"
        @input="onInput"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
.text-input {
  background-color: $semanticWhite;

  &__container {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: auto;
    gap: 0;
  }

  &__label {
    display: grid;
    grid-template-columns: auto auto;
    gap: 3px;
    justify-content: start;

    &-text {
      padding: 8px 0;
      font-family: Noto Sans JP;
      font-size: 14px;
      font-weight: 400;
      line-height: 18.2px;
      text-align: center;

      color: $textDefault;
    }
  }

  &__body {
    height: 100%;
    width: 100%;
    font-family: Noto Sans JP;
    font-size: 14px;
    font-weight: 400;
    line-height: 14px;
    letter-spacing: 0em;
    text-align: left;

    color: $textDefault;

    padding: 7px 8px;

    &:disabled {
      color: $textDisable;
      background-color: $surfaceSecondary;
    }
  }
}
</style>
